import React, { useMemo } from 'react'
import noop from 'lib/function/noop'
import styled from 'styled-components'
import OfferAirportOptionsGroupedList from '../Airport/OfferAirportOptionsGroupedList'
import { useAppSelector } from 'hooks/reduxHooks'
import NoAirportsOptionListItem from 'components/Flights/FlightsSearch/SearchWidget/FlightAirportSelect/NoAirportsOptionListItem'

const Wrapper = styled.div`
  position: relative; /* to make the <LoadingIndicator> work  */
`

interface Props {
  selectedAirport?: App.Airport
  onSelectAirport?: (airport: App.AirportLocation) => void
  withRadioButtons?: boolean
  searchPhrase?: string
}

function CharterFlightOfferAirportOptionsList(props: Props) {
  const {
    selectedAirport,
    onSelectAirport = noop,
    withRadioButtons,
    searchPhrase = '',
  } = props

  // Get all Australian airports from Redux state
  const australianAirports = useAppSelector(state => state.geo.originAirports)

  // Filter to show only Australian airports
  const airports = useMemo(() => {
    return australianAirports.filter(airport => airport.countryCode === 'AU')
  }, [australianAirports])

  const filteredAirports = useMemo(() => {
    const normalizedValue = searchPhrase.trim().toLowerCase()
    if (!normalizedValue) {
      return airports
    }

    return airports.filter(airport => {
      const searchableValue = `${airport.name} ${airport.code}`.toLowerCase()
      return searchableValue.includes(normalizedValue)
    })
  }, [airports, searchPhrase])

  const showNoResults = !!searchPhrase && !filteredAirports.length

  return (
    <Wrapper>
      {showNoResults && <NoAirportsOptionListItem inputValue={searchPhrase} />}
      {!showNoResults && (
        <OfferAirportOptionsGroupedList
          airports={filteredAirports}
          handleItemClick={onSelectAirport}
          selectedAirport={selectedAirport}
          withRadioButtons={withRadioButtons}
        />
      )}
    </Wrapper>
  )
}

export default CharterFlightOfferAirportOptionsList
